module.exports = __webpack_public_path__ + "static/media/545JamesPBrawleyDrNW_2018-06-12_101.5e95e55b.jpg";